import { createContext } from 'react'

interface OutstandingFilterContextType {
  isOutstandingFilterOn: boolean
  toggleIsOutstandingFilter: () => void
  isLoadingOutstandingFilterSettings: boolean
  isOutstandingFilterSettingsAllInactive: boolean
  isReceiptOutstandingFilterSettingsOn: boolean
  isNoteOutstandingFilterSettingsOn: boolean
  isCategoryOutstandingFilterSettingsOn: boolean
}

export const OutstandingFilterContext =
  createContext<OutstandingFilterContextType | null>(null)
